import styled from "styled-components";
import {SideMenuItemsListDefaultBox} from "./side-menu-items-list.default.box";

export const SideMenuItemsListCasino888Box = styled(SideMenuItemsListDefaultBox)`
    margin: 0;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        &::after {
            display: block;
            content: "";
            position: relative;
            top: 0.5rem;
            background-color: ${({theme}) => theme.colors.backgroundLight};
            width: 100%;
            height: 1px;
        }
    }
`;
